import "./LocationsBanner.scss";
import { useMemo } from "react";
import { useRecoilState } from "recoil";
import { availableAddonsState } from "../../state/atoms";
import { getLocationAddonPrice } from "../../service/SubscriptionService";
import Price from "./misc/Price";
import { SubStatusDtoPlanCycleEnum } from "../../generated/account-client";
import MainAppLocationIcon from "../icons/MainAppLocationIcon";

export default function LocationsBanner() {
  const [availableAddons] = useRecoilState(availableAddonsState);
  const locationAddonPrice = useMemo(
    () => getLocationAddonPrice(availableAddons),
    [availableAddons]
  );

  return (
    <section className={"promo-banner locations-banner"}>
      <h3>My Locations</h3>
      <p>
        Manage all your storefronts and brands from a single account. Add
        locations for only{" "}
        <Price
          amount={locationAddonPrice}
          cycle={SubStatusDtoPlanCycleEnum.Monthly}
          light
        />
        .
      </p>
      <div className={"circle"}>
        <MainAppLocationIcon color="#565656"/>
      </div>
    </section>
  );
}
